<!-- Page Content -->

<!-- Animation -->

<div class="row" style="margin: 0%;">
    <div class="col-md-12">


        <!-- Tab panes -->
        
            
                <div class="row"
                     style="margin:0;">
                    
                    <div class="col-sm-4">
                        <a href=""
                           style="text-decoration:underline;font-size:20px;">
                            <img src="../../../assets/images/New_Analysis_2.png"
                                 alt="Phase2"
                                 id="img_Phase2"
                                 style="width: 600px;    height: 160px;margin-top:5%;">


                        </a>
                        <button class="NewHomeButton"
                                (click)="ShowStasticalDiv($event)">

                                Segmentation Analysis
                        </button>
                    </div>

                   
                    <div class="col-sm-4">
                        <a href=""
                        style="text-decoration:underline;font-size:20px;">
                         <img src="../../../assets/images/New_Analysis_1.png"
                              alt="Phase2"
                              id="img_Phase2"
                              style="width: 600px;    height: 160px;margin-top:5%;">


                     </a>
                     <button class="NewHomeButton"
                             (click)="ShowNumericalDiv($event)">
                             Multi-Variate Analyzer
                         <!-- Turnover Trend Analysis -->
                     </button>
                    </div>

                    <div class="col-sm-4">
                        <a href=""
                        style="text-decoration:underline;font-size:20px;">
                         <img src="../../../assets/images/textanalysis-dark.png"
                              alt="Phase2"
                              id="img_Phase2"
                              style="width: 600px;    height: 160px;margin-top:5%;">


                     </a>
                     <button class="NewHomeButton"
                             (click)="ShowTextDiv($event)">
                             Text Analysis
                         <!-- Turnover Trend Analysis -->
                     </button>
                    </div>
                   

                    



                   
                </div>
                <div class="row"
                     style="margin:0;">
                    <!-- <div class="col-sm-1">

                    </div> -->
                    <div class="col-sm-4"
                         style="width: 500px;">
                        <p style="text-align:justify;font-size:12px;margin-top:3%;">Automated decision trees -
                            Create your own ML enabled segmentations to proactively identify segments with highest
                            risk of turnover</p>

                        <p style="text-align:justify;font-size:12px;margin-top:3%;">Use it when you want to extract readymade analysis using multiple behaviors against turnover </p>
                            

                    </div>
                    <!-- <div class="col-sm-2">

                    </div> -->
                    <div class="col-sm-4"  style="width: 500px;">
                        <p style="text-align:justify;font-size:12px;margin-top:3%;">Automated trends -
                            Perform analysis to review historic trends across the business unit you select for each of the top factors in segmentation</p>
                            <p style="text-align:justify;font-size:12px;margin-top:3%;">Use it when you want to validate any specific behavior/hypothesis against turnover. 
                            </p>
                    </div>
                    <!-- <div class="col-sm-1">

                    </div> -->
                    
                </div>
                <div class="row"
                     style="margin:0;">
                    <div class="col-sm-12">
                        <div class="alert alert-success"
                             role="alert">
                            <strong>Note : </strong>The protection of your personal data is very important to
                            Accenture.
                            Accenture is committed to keeping your personal data secure, and processing it in
                            accordance with, applicable data protection laws and our internal policies,
                            including <a
                               href="http://policies.accenture.com/Pages/0001-0100/0090.aspx?rd=1&Country=United+Kingdom"
                               target="_blank">Accenture’s Global Data Privacy Policy 0090. </a>
                            Accenture invites you to carefully read its
                            <a href="http://in.accenture.com/protectingaccenture/data-security/5422-2/"
                               target="_blank">privacy statement </a>, which includes important information on why
                            and how Accenture is processing your personal data.
                            <br />
                            When extracting summary values from graphs or any information from the tool, please
                            label it as "Accenture Highly Confidential"

                        </div>
                    </div>

                </div>
            

        

    
</div>
</div>


